<template>
  <b-row >
      <b-col>

        <b-row>

          <slot name="infoHeader"></slot>

          <slot name="info"></slot>
        </b-row>
      </b-col>

      <b-col cols="12" class="my-2">
        <slot name="form" v-if="mostrarFormFilter"></slot>
         <slot name="filtroAplicado"></slot>
      </b-col>

      <slot name="formFooter"></slot>

    </b-row>

</template>

<script>
export default {
  name: 'SGPFiltroComponent',

  props: {
    mostrarFiltroTexto: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      mostrarFormFilter: true,
    }
  },

  methods: {
    controlarFormFilter () {
      this.mostrarFormFilter = !this.mostrarFormFilter
    },

    changeTextoBusca (val) {
      this.$emit('sgpFiltroTextInputChange', val)
    },

    filtrarFormFilterDados (dados) {
      console.log(dados)
    }
  }
}
</script>